/* 🤖 this file was generated by svg-to-ts */
export const matIconLocalCafe: {
  name: 'local-cafe';
  data: string;
} = {
  name: 'local-cafe',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 5v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h10m4-2H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm-2 5V5h2v3h-2zm2 11H2v2h18v-2z"/></svg>`
};
